<template>
  <div class="container">
    <div class="container-header">
      <el-form class="upload-form" :inline="true" :model="searchData" :rules="searchRules" ref="searchForm">
        <el-form-item prop="vendorId" label="买手店">
          <el-select clearable filterable v-model="searchData.vendorId" placeholder="请选择">
            <el-option
              v-for="item, index in vendorList"
              :key="index"
              :label="item.vendorName"
              :value="item.vendorId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="settlementNo" label="订单编号">
          <el-input style="width:200px" clearable v-model="searchData.settlementNo" placeholder="请输入"></el-input>
        </el-form-item>
        <el-button class="item" type="primary" @click="search">查询</el-button>
        <el-button class="item" type="danger" @click="open">废除订单</el-button>
      </el-form>
    </div>

    <div class="container-main">
      <div class="scroll-content">
        <el-table
          ref="table"
          v-loading="tableLoading"
          :data="tableData"
          :height="tableHeight + 'px'"
        >
          <el-table-column prop="settlementNo" label="订单信息"></el-table-column>
          <el-table-column prop="purchaseOrderNo" label="原单号"></el-table-column>
          <el-table-column prop="vendorName" label="买手店"></el-table-column>
          <el-table-column prop="orderAmount" label="结算价"></el-table-column>
          <el-table-column prop="orderCurrency" label="币种"></el-table-column>
          <el-table-column prop="orderShippedTime" label="完结日期">
            <template slot-scope="scope">
              <span>{{ dateFormat(scope.row.orderShippedTime) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="orderRepealTime" label="被废除日期">
            <template slot-scope="scope">
              <span>{{ dateFormat(scope.row.orderRepealTime) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="orderRepealType" label="废除类型">
            <template slot-scope="scope">
              <span v-if="scope.row.orderRepealType == 1">作废</span>
              <span v-if="scope.row.orderRepealType == 2">豁免</span>
              <span v-if="scope.row.orderRepealType == 3">不可结算</span>
            </template>
          </el-table-column>
          <el-table-column prop="orderRepealRemark" label="备注说明"></el-table-column>
        </el-table>
      </div>
    </div>

    <div class="container-footer">
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="searchData.pageNo"
          :page-sizes="pageSizeArr"
          :page-size="searchData.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
      ></el-pagination>
    </div>

    <el-dialog title="废弃订单" :visible.sync="openDialog" width="600px">
      <div class="dialog-content">
        <el-form class="upload-form" :model="formData" :rules="formDataRules" ref="editData">
          <el-form-item prop="settlementNo" label="订单信息">
            <el-input v-model="formData.settlementNo" placeholder="请输入" @keyup.enter.native="getOrderInfo"></el-input>
          </el-form-item>
          <template v-if="orderInfo.settlementNo">
            <el-form-item label="关联订单">
              <span>{{ orderInfo.purchaseOrderNo }}</span>
            </el-form-item>
            <el-form-item label="结算价">
              <span>{{ orderInfo.orderAmount }}</span>
            </el-form-item>
            <el-form-item label="币种">
              <span>{{ orderInfo.orderCurrency }}</span>
            </el-form-item>
            <el-form-item prop="orderRepealType" label="废除类型">
              <el-select class="item" clearable v-model="formData.orderRepealType" placeholder="请选择">
                <el-option
                  v-for="item, index in options1"
                  :key="index"
                  :label="item.text"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="orderRepealRemark" label="备注">
              <el-input v-model="formData.orderRepealRemark" type="textarea" placeholder="请输入" maxlength="100"></el-input>
            </el-form-item>
          </template>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="openDialog = false">取消</el-button>
        <el-button type="primary" :loading="createLoading" :disabled="!orderInfo.settlementNo" @click="create">
          {{ createLoading ? '提交中...' : '确认' }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import utils from "@/utils/util";
import { getVendorListRF, settleOrderList, getSettleOrderInfo, settleOrderSubmit } from "./api";

export default {
  components: {},
  data() {
    return {
      searchData: {
        pageNo: 1,
        pageSize: 20,
        vendorId: '',
        settlementNo: '',
      },
      searchRules: {
        vendorId: [{ required: false, message: '请选择买手店', trigger: 'blur' }],
        settlementNo: [{ required: false, message: '请输入订单编号', trigger: 'blur' }],
      },
      vendorList: [],
      tableData: [],
      pageSizeArr: [10, 20, 50, 100],
      total: 0,
      tableLoading: false,
      tableHeight: null,
      formData: {
        settlementNo: '',
        orderRepealType: '',
        orderRepealRemark: '',
      },
      formDataRules: {
        settlementNo: [{ required: true, message: '请输入订单信息', trigger: 'blur' }],
        orderRepealType: [{ required: true, message: '请选择废除类型', trigger: 'blur' }],
      },
      orderInfo: {
        settlementNo: '',
        purchaseOrderNo: '',
        orderAmount: '',
        orderCurrency: '',
      },
      openDialog: false,
      createLoading: false,
      options1: [
        { text: '作废', value: 1 },
        { text: '豁免', value: 2 },
        { text: '不可结算', value: 3 },
      ],
    };
  },
  computed: {

  },
  methods: {
    handleSizeChange(val) {
      this.searchData.pageNo = 1
      this.searchData.pageSize = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.searchData.pageNo = val
      this.getList()
    },
    async getVendor() {
      const res = await getVendorListRF();
      if (res.data.success) {
        this.vendorList = res.data.data;
      } else {
        this.$message.error(res.data.message);
      }
    },
    async getList() {
      this.tableLoading = true;
      const body = this.formaterObj(this.searchData);
      const res = await settleOrderList(body);
      this.tableLoading = false;
      if (res.data.success) {
        this.tableData = res.data.data.list || [];
        this.total = res.data.data.total;
      } else {
        this.$message.error(res.data.message);
      }
    },
    async search() {
      const isValidate = await this.validFormData('searchForm');
      if (!isValidate) return;
      this.searchData.pageNo = 1;
      this.getList();
    },
    open() {
      this.formData = {
        settlementNo: '',
        orderRepealType: '',
        orderRepealRemark: ''
      };
      this.orderInfo = {
        settlementNo: '',
        purchaseOrderNo: '',
        orderAmount: '',
        orderCurrency: ''
      };
      this.openDialog = true;
    },
    async getOrderInfo () {
      const { settlementNo } = this.formData;
      const res = await getSettleOrderInfo(settlementNo);
      if (res.data.success) {
        this.orderInfo = res.data.data;
      } else {
        this.orderInfo = {
          settlementNo: '',
          purchaseOrderNo: '',
          orderAmount: '',
          orderCurrency: ''
        };
        this.$message.error(res.data.message);
      }
    },
    async submit() {
      this.createLoading = true;
      const body = this.formaterObj(this.formData);
      const res = await settleOrderSubmit(body);
      this.createLoading = false;
      if (res.data.success) {
        this.$message.success(res.data.data || "操作成功！");
        this.openDialog = false;
        this.search();
      } else {
        this.$message.error(res.data.message);
      }
    },
    async create() {
      const isValidate = await this.validFormData('editData');
      if (!isValidate) return;
      this.submit();
    },
    formaterObj(obj = {}) {
      const body = JSON.parse(JSON.stringify(obj));
      const data = {};
      for (const key in body) {
        const value = body[key];
        if (value === '' || value === null || value === undefined) continue;
        data[key] = value;
      }
      return data;
    },
    validFormData(ref = '') {
      return new Promise(resolve => {
        this.$refs[ref].validate((valid) => {
          if (valid) {
            resolve(true);
          } else {
            resolve(false);
          }
        });
      });
    },
    dateFormat(time) {
      if (!time) {
        return "";
      }
      return utils.dateFormat(new Date(time), "yyyy-MM-dd hh:mm:ss");
    },
  },
  async mounted() {
    this.tableHeight = document.querySelector('.container-main').offsetHeight;
    this.getVendor();
    this.search();
  },
}
</script>

<style lang="less" scoped>
  .container {
    height: calc(100% - 40px);
    display: flex;
    align-items: start;
    flex-direction: column;
    margin: 20px;
    margin-bottom: 0;
    overflow: hidden;
    box-sizing: border-box;
    .item {
      margin-right: 10px;
      &:last-child {
        margin-right: 0;
      }
    }
    .container-header {
      width: 100%;
    }
    .container-main {
      flex: 1;
      width: 100%;
      overflow: auto;
    }
    .container-footer {
      width: 100%;
      background: white;
      text-align: right;
    }
    .el-dialog {
      margin-top: 0 !important;
      top: 50%;
      transform: translateY(-50%);
    }
    .dialog-content {

    }
  }
</style>
